export class PartySizeDuration {
    constructor(
        public partySize: number | null,
        public duration: number
    ) { }
}
